<template>
    <v-container fluid class="container-full-bg-gray" v-if="screen_data.showTrial && userData">
        <v-card class="working-hours-trial-card">
            <v-card-title>
                Control de Fichaje
            </v-card-title>
            <v-card-text>
                <div class="centered-content">
                    <img src="/bank_new_icon.png"/>
                    <div class="primary--text font-30 pb-7">
                        Control de Fichaje
                    </div>
                    <div class="font-weight-light pb-3">
                        Descubre la facilidad de gestionar<br>
                        el control horario de tu empresa con nosotros.
                        <!-- <a href="https://www.youtube.com/watch?v=USITS-FsCo8" target="_blank">(DEMO)</a> -->
                    </div>
                    <template>
                        <div class="font-weight-bold">Prueba Gratuita*</div>
                        <div class="pb-7 flex flex-col">
                            <small>*La prueba gratuita incluye el uso del control de fichaje en esta empresa por un máximo de 7 días.</small>
                        </div>
                        <v-btn
                            rounded
                            color="primary"
                            :loading="screen_data.loading"
                            @click="activateWorkingHoursTrial"
                            >
                            Empieza gratis
                        </v-btn>
                    </template>
                </div>
            </v-card-text>
        </v-card>

        <!-- Diálogo para redirección a Mis Datos -->
        <v-dialog v-model="showRedirectDialog" max-width="500" persistent>
            <v-card>
                <v-card-title class="headline primary--text">
                    Control de Fichaje
                </v-card-title>
                <v-card-text>
                    <p class="text-body-1">
                        Ya has utilizado el período de prueba. Para seguir usando Control de Fichaje, contrata el servicio.
                    </p>
                    <p class="text-body-1 mt-3">
                        Serás redirigido a la vista de "Mis Datos" para gestionar tu contrato.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        @click="showRedirectDialog = false"
                    >
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="redirectToMyData"
                    >
                        Aceptar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import { ApiWorkingHoursContractRepository } from "../modules/working_hours/infra/ApiWorkingHoursContractRepository";
import { VueWorkingHoursContractScreenData } from "../modules/working_hours/infra/VueWorkingHoursContractScreenData";
import { WorkingHoursContractComponent } from "../modules/working_hours/app/WorkingHoursContractComponent";
import { mapGetters } from "vuex";

export default {
    name: 'WorkingHoursTrial',
    components: {

    },
    props: {
        companydb_id: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        const screen_data = new VueWorkingHoursContractScreenData();
        return {
            screen_data: screen_data,
            working_hours_trial_component: null,
            showRedirectDialog: false,
            redirectDialogAction: 'contratar'
        }
    },
    async mounted() {
        let working_hours_contract_repo = new ApiWorkingHoursContractRepository();
        this.working_hours_trial_component = new WorkingHoursContractComponent(working_hours_contract_repo, this.screen_data);
        let contractStatus = await this.working_hours_trial_component.checkWorkingHoursContractShowTrial(this.userData.user, this.companydb_id);

        // if have a expired trial, show the purchase or redirect dialog according to the user type
        // But only if permission is already loaded
        if (contractStatus && contractStatus.has_expired_trial && !contractStatus.has_active) {

            // If permission is available, decide what to show
            if (this.permission && this.permission.is_customer !== undefined) {
                if (this.permission.is_customer) {
                    // If is customer, show the redirect dialog to My Data
                    this.redirectDialogAction = 'contratar';
                    this.showRedirectDialog = true;
                } else {
                    // If is not customer, show the normal payment modal
                    this.$store.dispatch('dialog_payment/openContractModal', {
                        msg: 'Tu período de prueba ha finalizado. Contrata el servicio para seguir usando Control de Fichaje.',
                        distributor: false,
                        facturae_client: false,
                        is_company_selector_visible: false,
                        is_tax_data_filled: true,
                        can_show_document_services_and_banks: false
                    });
                }
            }
        }
    },
    watch: {
        // Watch para cuando permission.is_customer cambie a true
        'permission.is_customer': {
            async handler(newValue, oldValue) {

                // If changes from false to true, check the contract status
                if (newValue === true && oldValue === false) {
                    if (!this.working_hours_trial_component) {
                        return;
                    }

                    let contractStatus = await this.working_hours_trial_component.checkWorkingHoursContractShowTrial(this.userData.user, this.companydb_id);

                    if (contractStatus && contractStatus.has_expired_trial && !contractStatus.has_active) {
                        // Close the payment modal if it is open
                        this.$store.dispatch('dialog_payment/closeContractModal');

                        // Show the redirect dialog
                        this.redirectDialogAction = 'contratar';
                        this.showRedirectDialog = true;
                    }
                }
            },
            immediate: false
        },
        companydb_id: async function(newVal, oldVal) {
            if (newVal !== oldVal) {
                // Check if the new company has an active contract
                let working_hours_contract_repo = new ApiWorkingHoursContractRepository();
                let contractStatus = await working_hours_contract_repo.check_user_working_hours_active_contract(this.userData.user, newVal);

                if (contractStatus.has_active) {
                    // If has an active contract, redirect to working hours
                    this.$router.push({
                        name: 'working-hours',
                        params: { companydb_id: newVal }
                    }).catch(() => {});
                } else {
                    // If has no contract, reload the trial page with the new company
                    this.working_hours_trial_component = new WorkingHoursContractComponent(working_hours_contract_repo, this.screen_data);
                    contractStatus = await this.working_hours_trial_component.checkWorkingHoursContractShowTrial(this.userData.user, newVal);

                    // If has an expired trial, show the purchase or redirect dialog according to the user type
                    if (contractStatus && contractStatus.has_expired_trial && !contractStatus.has_active) {
                        if (this.permission && this.permission.is_customer) {
                            // If is customer, show the redirect dialog to My Data
                            this.redirectDialogAction = 'contratar';
                            this.showRedirectDialog = true;
                        } else {
                            // If is not customer, show the normal payment modal
                            this.$store.dispatch('dialog_payment/openContractModal', {
                                msg: 'Tu período de prueba ha finalizado. Contrata el servicio para seguir usando Control de Fichaje.',
                                distributor: false,
                                facturae_client: false,
                                is_company_selector_visible: false,
                                is_tax_data_filled: true,
                                can_show_document_services_and_banks: false
                            });
                        }
                    }
                }
            }
        },

        // Watch para cambios desde el store (cuando se selecciona empresa en el selector)
        '$store.state.currentCompany': {
            async handler(newCompany, oldCompany) {
                if (newCompany && oldCompany && newCompany.id !== oldCompany.id) {
                    // Verificar si la nueva empresa tiene contrato activo
                    let working_hours_contract_repo = new ApiWorkingHoursContractRepository();
                    let contractStatus = await working_hours_contract_repo.check_user_working_hours_active_contract(this.userData.user, newCompany.id);

                    if (contractStatus.has_active) {
                        // Si tiene contrato activo, redirigir a working hours
                        this.$router.push({
                            name: 'working-hours',
                            params: { companydb_id: newCompany.id }
                        }).catch(() => {});
                    } else {
                        // Si no tiene contrato, redirigir a trial con el nuevo companydb_id
                        this.$router.push({
                            name: 'working-hours-trial',
                            params: { companydb_id: newCompany.id }
                        }).catch(() => {});
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        async activateWorkingHoursTrial(){
            let contractStatus = await this.working_hours_trial_component.checkWorkingHoursContractShowTrial(this.userData.user, this.companydb_id);

            if (contractStatus && contractStatus.has_expired_trial) {
                if (this.permission && this.permission.is_customer) {
                    // If is customer, show the redirect dialog to My Data
                    this.redirectDialogAction = 'contratar';
                    this.showRedirectDialog = true;
                } else {
                    // If is not customer, show the normal payment modal
                    this.$store.dispatch('dialog_payment/openContractModal', {
                        msg: 'Ya has utilizado el período de prueba. Para seguir usando Control de Fichaje, contrata el servicio.',
                        distributor: false,
                        facturae_client: false,
                        is_company_selector_visible: false,
                        is_tax_data_filled: true,
                        can_show_document_services_and_banks: false
                    });
                }
                return;
            }

            let res = await this.working_hours_trial_component.activateWorkingHoursTrialContract(this.userData.user, this.companydb_id);
            if (res) {
                window.location.href = `/${this.companydb_id}/working-hours`;
            }
            else {
                console.log("Ha habido un error en la creacion del contrato trial de working hours");
            }
        },
        redirectToMyData() {
            this.showRedirectDialog = false;
            this.$router.push({
                name: 'profile',
                params: { companydb_id: this.companydb_id }
            }).catch(() => {});
        }
    },
    computed: {
        ...mapGetters({
            userData: 'me/userData',
            permission: 'permissions/permission',
            got_feature:'got_feature',
        }),
    }
}
</script>

<style scoped>
.font-30 {
  font-size: 30px;
}
.working-hours-trial-card {
  height: 99%;
  min-height: 480px;
  border-radius: 12px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.working-hours-trial-card .v-card__title {
  color: var(--v-primary-base);
  font-size: 20px;
  font-weight: 500;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 30px;
}

.working-hours-trial-card .centered-content {
  text-align: center;
  width: 98%;
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>